import CommentInput from './CommentInput'

export default CommentInput
